import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';

/**
 * The `PageHero` component displays the hero on a page page.
 *
 * ### Props
 *
 * - `page`
 */
export default class SearchButton extends Component {
  view() {
    return (
      <div className={classList('Navigation ButtonGroup App-backControl dl-search')}>
        <LinkButton
          className="Button Navigation-back Button--icon"
          href={app.route('search')}
        />
      </div>
    );
  }
}
